var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.$apollo.loading)?_c('article',{class:{
    white: _vm.content.white_background,
    'has-image': _vm.content.body && _vm.content.body[0].primary.header_background
  }},[_c('prismic-slices',{attrs:{"uid":_vm.uid,"query-name":this.$route.path.startsWith('/article') ? 'article' : 'page'}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }